















import { Component, Vue, Provide } from "vue-property-decorator";
import AdministrativeApproval from "@/components/Services/AdministrativeApproval.vue";
import GovernmentHotline from "@/components/Services/GovernmentHotline.vue";
import PolicyRelease from "@/components/Services/PolicyRelease.vue";
import { Tab, Tabs } from "vant";
@Component({
  components: {
    AdministrativeApproval,
    GovernmentHotline,
    PolicyRelease,
    Tab,
    Tabs
  }
})
export default class BusinessService extends Vue {
  currentIndex: string = "";
}
